import { useToasts } from '@/hooks/useToasts'
import { useTranslation } from 'react-i18next'

import { useUpdateRuleMutation } from '@/graphql/generated/hooks'

import { RulesType } from '../utils/utils'

export const useUpdateRule = () => {
  const { t } = useTranslation()
  const { showError } = useToasts()
  const [updateRule] = useUpdateRuleMutation()

  const updateRuleStatus = async (rule: RulesType) => {
    const { id, status: isActive } = rule
    try {
      await updateRule({
        variables: {
          input: { id, status: !isActive },
        },
      })
    } catch (e) {
      showError(t('automations:v2_rule_update_error'))
    }
  }

  return {
    updateRuleStatus,
  }
}
